<script lang="ts">
  import { onMount } from "svelte";
  import {HttpResponse, request} from './httphelper';
  export let error = '';
  let names = [];
  let currentName = undefined;
  let currentNameIndex = -1;
  let swipeStartX = -1;
  let evaluatedIndices = [];
  let allNamesEvaluated = false;
  $: namesLeftCount = names.length - evaluatedIndices.length;
  const swipeThreshold = 50;

  onMount(async () => {
		const response = await request<Name[]>(new Request(`/names_to_evaluate.php`));
    if (!response.ok || response.apiResponseStatus != 0 || !response.parsedBody) {
      error = 'Fehler beim Abrufen der Namen ' + response.apiResponseStatus;
      return ;
    }
    else {
      names = response.parsedBody;
      currentName = getNextName();
    }

    window.history.pushState('', '', '/evaluate');
	});

  function handleSwipeStart(x : number) {
    swipeStartX = x;
  }
  async function handleSwipeEnd(x : number) {
    if (swipeStartX > 0) {
      let horizontalDistance = x-swipeStartX;
      let swipe = "left";
      if (Math.abs(horizontalDistance) > swipeThreshold) {
        evaluatedIndices = [...evaluatedIndices, currentNameIndex];
        if (horizontalDistance > 0) {
          swipe = "right";
        }
        postSwipe(swipe);
        displayNextName();
      }
    }
    swipeStartX = -1;
  }

  function displayNextName() {
    currentName = getNextName();
    if (!currentName) {
      allNamesEvaluated = true;
    }
  }

  async function postSwipe(direction : string) {
    const response = request<any>(new Request(`/swipe.php`,
          {
            method : 'POST',
            body:JSON.stringify({
              "nameid" : currentName.id,
              "swipe" : direction,
            })
          }
          ));
  }

  function handleTouchStart(e : TouchEvent) {
    handleSwipeStart(e.changedTouches[0].pageX);
  }

  function handleTouchEnd(e : TouchEvent) {
    handleSwipeEnd(e.changedTouches[e.changedTouches.length-1].pageX);
  }

  function handleMouseDown(e : MouseEvent) {
    handleSwipeStart(e.pageX);
  }

  function handleMouseUp(e : MouseEvent) {
    handleSwipeEnd(e.pageX);
  }

  function getNextName() : Name {
    if (evaluatedIndices.length >= names.length) {
      return undefined;
    }
    let index = Math.floor(Math.random() * names.length);
    while (evaluatedIndices.includes(index)) {
      index = Math.floor(Math.random() * names.length);
    }
    currentNameIndex = index;
    return names[currentNameIndex];
  }

  interface Name {
    id : number,
    name : string,
    sex : string,
    origin : string,
    meaning : string,
  }


</script>

{#if allNamesEvaluated}
Du hast alle Namen bewertet.
{:else if currentName}
<div style="display:flex;justify-content:space-between;align-items:center;">
  <div class="arrow" style="color:red;" on:click={() => {postSwipe("left"); displayNextName();}}>&larr;</div>
  <div>Übrig: {namesLeftCount}</div>
  <div class="arrow" style="color:green;" on:click={() => {postSwipe("right"); displayNextName();}}>&rarr;</div>
</div>
<div class="name"
on:mousedown={handleMouseDown}
on:mouseup={handleMouseUp}
on:touchstart|passive={handleTouchStart}
on:touchend={handleTouchEnd}>
  <h3>{currentName.name}</h3>
  <h4>Herkunft</h4>
  {currentName.origin}
  <h4>Bedeutung</h4>
  {currentName.meaning}
</div>

{/if}
<style>
  .name {
    border: 5px solid black;
    padding: 5px;
    margin: 3px;
  }
  .arrow {
    font-size: xx-large;
    font-weight: bold;
  }
</style>